import React, { useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { TypeAnimation } from "react-type-animation";

export default function HeroSection() {
  const [showCvModal, setShowCvModal] = useState(false);
  const [cvStep, setCvStep] = useState("language");
  const [selectedLanguage, setSelectedLanguage] = useState("");

  const cvFiles = {
    en: {
      pdf: "/docs/Lilibeth S. -  Resume(en-pdf).pdf",
      doc: "/docs/Lilibeth S. -  Resume(en-doc).docx",
    },
    es: {
      pdf: "/docs/Lilibeth S. - Resume(es-pdf).pdf",
      doc: "/docs/Lilibeth S. - Resume(es-doc).docx",
    },
  };

  const openCvModal = () => {
    setSelectedLanguage("");
    setCvStep("language");
    setShowCvModal(true);
  };

  const handleSelectLanguage = (language) => {
    setSelectedLanguage(language);
    setCvStep("format");
  };

  const getDownloadPath = (format) => {
    if (!selectedLanguage) return "#";
    return encodeURI(cvFiles[selectedLanguage][format]);
  };

  return (
    <Container fluid id="home" className="">
      <Row className="hero justify-content-center">
        <Col className="container-default">
          <Row>
            <Col>
              <p className="hero--pre-title">Hello, world!</p>
              <p className="hero--title">
                <span className="color-pink">const</span>{" "}
                <span className="color-orange">
                  <i>name</i>
                </span>{" "}
                <span className="color-blue">=</span>{" "}
                <span>
                  <TypeAnimation
                    sequence={[
                      '"Lilibeth Sanchez";',
                      3000,
                      ,
                      '"Daily San";',
                      3000,
                      ,
                    ]}
                    className="typing"
                    speed={{ type: "keyStrokeDelayInMs", value: 150 }}
                    deletionSpeed={40}
                    repeat={Infinity}
                  />
                </span>
              </p>
              <p className="hero--description">
                I'm a <span>Full Stack Engineer</span> focused on{" "}
                <span>scalable web platforms and distributed systems</span>.
                Experienced with <span>React, Angular, Vue, Node.js, NestJS</span>,
                cloud and DevOps practices, event-driven architectures, and{" "}
                <span>relational and non-relational databases</span>.
              </p>
              <Row>
                <Col>
                  <Button href="#about" className="btn-link color-green me-5">
                    about me
                  </Button>
                  <Button href="#projects" className="btn-link color-default">
                    projects
                  </Button>
                  <Button
                    type="button"
                    onClick={openCvModal}
                    className="btn-link color-blue ms-sm-5 ms-0 mt-3 mt-sm-0 d-inline-block"
                  >
                    dowload resume
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>

      <Modal
        show={showCvModal}
        onHide={() => setShowCvModal(false)}
        centered
        contentClassName="cv-modal-content"
      >
        <Modal.Header closeButton className="cv-modal-header">
          <Modal.Title>
            {cvStep === "language" ? "Choose CV Language" : "Choose Format"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="cv-modal-body">
          <div className="cv-modal-actions">
            {cvStep === "language" ? (
              <>
                <Button
                  type="button"
                  className="btn-link color-blue"
                  onClick={() => handleSelectLanguage("en")}
                >
                  english
                </Button>
                <Button
                  type="button"
                  className="btn-link color-green"
                  onClick={() => handleSelectLanguage("es")}
                >
                  spanish
                </Button>
              </>
            ) : (
              <>
                <Button
                  as="a"
                  href={getDownloadPath("pdf")}
                  download
                  className="btn-link color-blue"
                  onClick={() => setShowCvModal(false)}
                >
                  pdf
                </Button>
                <Button
                  as="a"
                  href={getDownloadPath("doc")}
                  download
                  className="btn-link color-green"
                  onClick={() => setShowCvModal(false)}
                >
                  doc
                </Button>
                <Button
                  type="button"
                  className="btn-link color-comment"
                  onClick={() => setCvStep("language")}
                >
                  back
                </Button>
              </>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </Container>
  );
}
